import { ArrowUpRight } from "@phosphor-icons/react";
import { CLINIC } from "../data/site";
import { Reveal } from "./Reveal";
import { EnquiryDialog } from "./EnquiryDialog";

export const CTABand = () => (
  <section className="relative overflow-hidden bg-primary" data-testid="cta-band">
    <div
      aria-hidden
      className="pointer-events-none absolute -right-24 -top-24 select-none font-display text-[22rem] font-light italic leading-none text-white/[0.06]"
    >
      DK
    </div>
    <div className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <Reveal>
        <p className="text-xs font-medium uppercase tracking-[0.35em] text-white/60">Be true, be you</p>
        <h2 className="mt-4 max-w-3xl font-display text-5xl font-light leading-[1.05] tracking-tight text-white sm:text-6xl">
          Ready to <span className="italic">glow?</span>
        </h2>
        <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-white/75">
          Our goal is to strengthen your confidence and enhance your natural beauty with high-end,
          non-invasive treatments. Book a consultation or appointment today to bring out the best in yourself.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <EnquiryDialog
            defaultType="appointment"
            trigger={
              <button
                data-testid="cta-book-appointment-button"
                className="group flex items-center justify-center gap-2 bg-white px-8 py-4 text-xs font-medium uppercase tracking-[0.25em] text-primary transition-colors duration-300 hover:bg-white/90"
              >
                Book appointment
                <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </button>
            }
          />
          <EnquiryDialog
            defaultType="consultation"
            trigger={
              <button
                data-testid="cta-free-consultation-button"
                className="border border-white/40 px-8 py-4 text-xs font-medium uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:border-white hover:bg-white/10"
              >
                Free 15-min consultation
              </button>
            }
          />
        </div>
        <p className="mt-6 text-xs uppercase tracking-[0.2em] text-white/50">
          {CLINIC.phone} · {CLINIC.address}
        </p>
      </Reveal>
    </div>
  </section>
);
